module.exports = __webpack_public_path__ + "img/think_and_grow_rich.dc22e06f.jpg";